import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// PublicRoute adalah komponen untuk halaman yang hanya boleh diakses oleh pengguna yang belum login
// Jika pengguna sudah login, mereka akan diarahkan ke dashboard
const PublicRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Jika pengguna sudah login, arahkan ke dashboard
  if (currentUser) {
    return <Navigate to="/dashboard" />;
  }

  // Jika pengguna belum login, tampilkan halaman yang diminta
  return children;
};

export default PublicRoute;
